import React from 'react';
import styled from 'styled-components';
import AdminLayout from 'Components/Layout/AdminLayout';
import AdStatusBoard from 'Components/AdStatusBoard';
import { useParams } from 'react-router-dom';

const ContentContainer = styled.div`
  width: 100%;
  margin: 20px;
  overflow: auto;
  flex: 1;
`;

const AdStatusPage = () => {
  const { adId } = useParams<{ adId: string }>();
  return (
    <AdminLayout>
      <ContentContainer>
        <AdStatusBoard adId={adId} />
      </ContentContainer>
    </AdminLayout>
  );
};
export default AdStatusPage;
